var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMicrophoneSlash2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D4848751-779B-49CF-8718-EED86AB98918") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-300.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone-slash",
    transform: "translate(300.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25,11 L7.25,6 C7.25,3.38000011 9.38000011,1.25 12,1.25 C14.6199999,1.25 16.75,3.38000011 16.75,6 L16.75,6.30000019 C16.75,6.71000019 16.41,7.05000019 16,7.05000019 C15.59,7.05000019 15.25,6.71000019 15.25,6.30000019 L15.25,6 C15.25,4.21000004 13.79,2.75 12,2.75 C10.21,2.75 8.75,4.21000004 8.75,6 L8.75,11 C8.75,11.41 8.41,11.75 8,11.75 C7.59,11.75 7.25,11.41 7.25,11 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48064214,14.6899996 C8.20064214,14.3799996 8.23064232,13.9100001 8.53064233,13.6300001 C8.84064233,13.3500001 9.31064281,13.3800003 9.59064281,13.6800003 C10.2006428,14.3600003 11.0806425,14.75 12.0006425,14.75 C13.7906425,14.75 15.2506428,13.29 15.2506428,11.5 L15.2506428,11 C15.2506428,10.59 15.5906428,10.25 16.0006428,10.25 C16.4106428,10.25 16.7506428,10.59 16.7506428,11 L16.7506428,11.5 C16.7506428,14.1199999 14.6206424,16.25 12.0006425,16.25 C10.6606425,16.25 9.38064212,15.6799996 8.48064214,14.6899996 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26933153,17.4999027 C5.96933152,17.2199027 5.94933157,16.7399033 6.22933157,16.4399033 C6.51933156,16.1299033 6.99933177,16.1199023 7.29933178,16.3999023 C8.57933176,17.5899024 10.2493315,18.2499027 11.9993315,18.2499027 C15.7993314,18.2499027 18.8993311,15.1499031 18.8993311,11.3499031 L18.8993311,9.64990234 C18.8993311,9.23990235 19.2393311,8.89990234 19.6493311,8.89990234 C20.0593311,8.89990234 20.3993311,9.23990235 20.3993311,9.64990234 L20.3993311,11.3499031 C20.3993311,15.9799032 16.6293316,19.7499027 11.9993315,19.7499027 C9.86933136,19.7499027 7.82933147,18.9499028 6.26933153,17.4999027 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2596097,14.6199026 C3.8196097,13.5799026 3.59960938,12.4899031 3.59960938,11.3499031 L3.59960938,9.64990234 C3.59960938,9.23990235 3.93960938,8.89990234 4.34960938,8.89990234 C4.75960937,8.89990234 5.09960938,9.23990235 5.09960938,9.64990234 L5.09960938,11.3499031 C5.09960938,12.2799031 5.27960932,13.1799024 5.63960934,14.0299025 C5.79960933,14.4099025 5.61960924,14.849903 5.23960924,15.009903 C5.14960924,15.059903 5.04960928,15.0799026 4.94960928,15.0799026 C4.65960929,15.0799026 4.3796097,14.9099026 4.2596097,14.6199026 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.389375,19.5197849 C3.09937501,19.2297849 3.09937501,18.7497835 3.389375,18.4597836 L19.5393753,2.30978516 C19.8293753,2.01978517 20.3093748,2.01978517 20.5993748,2.30978516 C20.8893748,2.59978515 20.8893748,3.07978508 20.5993748,3.36978507 L4.4593749,19.5197849 C4.3093749,19.6697849 4.11937495,19.7397842 3.91937494,19.7397842 C3.72937495,19.7397842 3.53937501,19.6697849 3.389375,19.5197849 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25,6 L10.25,3 C10.25,2.59 10.59,2.25 11,2.25 C11.41,2.25 11.75,2.59 11.75,3 L11.75,6 C11.75,6.41 11.41,6.75 11,6.75 C10.59,6.75 10.25,6.41 10.25,6 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,22 L11.25,19 C11.25,18.59 11.59,18.25 12,18.25 C12.41,18.25 12.75,18.59 12.75,19 L12.75,22 C12.75,22.41 12.41,22.75 12,22.75 C11.59,22.75 11.25,22.41 11.25,22 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMicrophoneSlash2);
export default __webpack_public_path__ + "static/media/vuesax-outline-microphone-slash_2.9d266494886e4ba6101fe47dfe7b6657.svg";
export { ForwardRef as ReactComponent };